/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountUpdateRequest} from '../models/AccountUpdateRequest';
import type {Error} from '../models/Error';

export interface DeleteAccount$Request {
    accountId: number;
}

export interface DeleteAccount$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteAccountRequest = createAction<PayloadData<void, DeleteAccount$Request>>('UPDATE_ACCOUNT__DELETE_ACCOUNT__REQUEST');
export const deleteAccountSuccess = createAction<PayloadData<void, DeleteAccount$Request>>('UPDATE_ACCOUNT__DELETE_ACCOUNT__SUCCESS');
export const deleteAccountFailure = createAction<PayloadData<Error, DeleteAccount$Request, true>>('UPDATE_ACCOUNT__DELETE_ACCOUNT__FAILURE');

export const deleteAccountActions = [
    deleteAccountRequest,
    deleteAccountSuccess,
    deleteAccountFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteAccount = (meta: DeleteAccount$Request, config?: DeleteAccount$Config) => {
    return {
        CALL_API: {
            types: deleteAccountActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/accounts/${meta.accountId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface RestoreAccount$Request {
    accountId: number;
}

export interface RestoreAccount$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const restoreAccountRequest = createAction<PayloadData<void, RestoreAccount$Request>>('UPDATE_ACCOUNT__RESTORE_ACCOUNT__REQUEST');
export const restoreAccountSuccess = createAction<PayloadData<void, RestoreAccount$Request>>('UPDATE_ACCOUNT__RESTORE_ACCOUNT__SUCCESS');
export const restoreAccountFailure = createAction<PayloadData<Error, RestoreAccount$Request, true>>('UPDATE_ACCOUNT__RESTORE_ACCOUNT__FAILURE');

export const restoreAccountActions = [
    restoreAccountRequest,
    restoreAccountSuccess,
    restoreAccountFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const restoreAccount = (meta: RestoreAccount$Request, config?: RestoreAccount$Config) => {
    return {
        CALL_API: {
            types: restoreAccountActions,
            method: ApiMethods.PATCH,
            endpoint: `/web-api/accounts/${meta.accountId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateAccount$Request {
    accountId: number;
    accountUpdateRequest: AccountUpdateRequest;
}

export interface UpdateAccount$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateAccountRequest = createAction<PayloadData<void, UpdateAccount$Request>>('UPDATE_ACCOUNT__UPDATE_ACCOUNT__REQUEST');
export const updateAccountSuccess = createAction<PayloadData<void, UpdateAccount$Request>>('UPDATE_ACCOUNT__UPDATE_ACCOUNT__SUCCESS');
export const updateAccountFailure = createAction<PayloadData<Error, UpdateAccount$Request, true>>('UPDATE_ACCOUNT__UPDATE_ACCOUNT__FAILURE');

export const updateAccountActions = [
    updateAccountRequest,
    updateAccountSuccess,
    updateAccountFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {AccountUpdateRequest} meta.accountUpdateRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateAccount = (meta: UpdateAccount$Request, config?: UpdateAccount$Config) => {
    return {
        CALL_API: {
            types: updateAccountActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/accounts/${meta.accountId}`,
            TRANSPORT_REQUEST_BODY: meta.accountUpdateRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

